export default __webpack_public_path__ + "static/media/usdxxLogo.dc98a05f.png";